var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatagridTierPerformance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "235px",
    height: "125px",
    viewBox: "0 0 235 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cross Tab - Simplified@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 235,
    height: 125,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cross-Tab---Simplified",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Widget/HorBar/CrossTab/Simplified",
    transform: "translate(0.270089, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Line-of-Business-vs.-Knowledge-/-Cross-Tab",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 235,
    height: 125
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bar-1--",
    transform: "translate(0.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#387997",
    x: 0,
    y: 0,
    width: 184,
    height: 30,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 188.57,
    y: 8,
    width: 32,
    height: 14
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bar-2",
    transform: "translate(0.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#387997",
    x: 0,
    y: 0,
    width: 157,
    height: 30,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 161.57,
    y: 7,
    width: 32,
    height: 14
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bar-3",
    transform: "translate(0.000000, 85.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#387997",
    x: 0,
    y: 0,
    width: 149,
    height: 30,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 154.57,
    y: 7,
    width: 32,
    height: 14
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatagridTierPerformance);
export default __webpack_public_path__ + "static/media/datagrid-tier-performance.c4f203ad95f812c2ee3ea8adcfb16e68.svg";
export { ForwardRef as ReactComponent };